import React, {createContext, useContext, useMemo} from "react";
import {useAuthState} from "react-firebase-hooks/auth";

import {GameManager} from "@repo/shared";

import {auth} from "~/firebase/firebase";

interface GameContextState {
  gameManager: GameManager | null;
}

const GameContext = createContext<GameContextState>({
  gameManager: null,
});

/**
 * This provider's SOLE responsibility is to create the singleton
 * GameManager instance and provide it to its children.
 * It does NOT contain the game loop.
 */
export const GameManagerProvider: React.FC<{children: React.ReactNode}> = ({
  children,
}) => {
  const [user] = useAuthState(auth);

  const gameManager = useMemo(() => {
    if (user) {
      return new GameManager();
    }
    return null;
  }, [user]);

  const value = useMemo(() => ({gameManager}), [gameManager]);

  return <GameContext.Provider value={value}>{children}</GameContext.Provider>;
};

export const useGame = (): GameContextState => {
  const context = useContext(GameContext);
  if (!context) throw new Error("useGame must be used within a GameProvider");
  return context;
};
